import { render, staticRenderFns } from "./DeleteLog.vue?vue&type=template&id=06247474&lang=pug"
import script from "./DeleteLog.vue?vue&type=script&lang=js"
export * from "./DeleteLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports